import { ref } from "vue";

// REQ-CD-11 — "async transitions are announced through a single
// aria-live="polite" region". A module-level singleton keeps that region
// single across the whole view without threading a prop through every
// component that needs to announce something.
const message = ref("");

export function useAnnouncer() {
  function announce(text: string): void {
    message.value = text;
  }
  return { message, announce };
}
